export default __webpack_public_path__ + "static/media/Krists.5730c472.png";